function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

function hexChannelToLinear(byte: number): number {
  const sRGB = byte / 255
  return sRGB <= 0.04045
    ? sRGB / 12.92
    : Math.pow((sRGB + 0.055) / 1.055, 2.4)
}

export function relativeLuminance(hex: string): number {
  const clean = hex.replace('#', '')
  if (clean.length !== 6) return 0
  const r = hexChannelToLinear(parseInt(clean.slice(0, 2), 16))
  const g = hexChannelToLinear(parseInt(clean.slice(2, 4), 16))
  const b = hexChannelToLinear(parseInt(clean.slice(4, 6), 16))
  return clamp(0.2126 * r + 0.7152 * g + 0.0722 * b, 0, 1)
}

export function contrastRatio(hex1: string, hex2: string): number {
  const l1 = relativeLuminance(hex1)
  const l2 = relativeLuminance(hex2)
  const lighter = Math.max(l1, l2)
  const darker = Math.min(l1, l2)
  return (lighter + 0.05) / (darker + 0.05)
}
